import React from 'react';
import {
    GradualQuestionSlideWrapper,
    QuestionContent,
    QuestionText,
    ButtonsWrapper,
    QuestionGroup,
} from 'pages/questionnaire/slides/gradual/GradualQuestionSlide.styled';
import { Questionnaire } from 'types/app';
import { PageTitle } from 'layout/page/Page.layout.styled';
import { getLocaleValue } from 'helpers/utils';
import { useTranslation } from 'react-i18next';
import IpsativeResponses from 'components/questionnaire/IpsativeResponses';
import Button from 'components/common/button/Button';

export interface GradualQuestionSlideProps {
    question?: Questionnaire.IIpsativeQuestion;
    gotoPrevious?: () => void;
    gotoNext?: () => void;
    onAnswer?: (questionWithResponse: Questionnaire.IIpsativeQuestion) => void;
    isDQ?: boolean;
}

const GradualQuestionSlide: React.FC<GradualQuestionSlideProps> = ({
    question,
    gotoPrevious,
    gotoNext,
    onAnswer,
    isDQ,
}) => {
    const { i18n, t } = useTranslation('translation');

    const handleAnswerSelect = (answer: Questionnaire.IIpsativeAnswer) => {
        if (question && onAnswer) {
            const updatedQuestion: Questionnaire.IIpsativeQuestion = {
                ...question,
                selectedAnswerId: answer.id,
            };
            onAnswer(updatedQuestion);
        }
    };

    if (!question) {
        return null;
    }

    return (
        <GradualQuestionSlideWrapper>
            <PageTitle style={{
                margin: '0 0 10px 0',
                fontSize: '16px',
                // display: 'none'
            }}>
                {isDQ ? t('questionnaire.depuisquand.title') : t('questionnaire.gradual.title')}
            </PageTitle>
            <QuestionContent>
                {question.group && (
                    <QuestionGroup>{getLocaleValue(question.group.label, i18n.language)}</QuestionGroup>
                )}
                <QuestionText>{getLocaleValue(question.label, i18n.language)}</QuestionText>
                <IpsativeResponses
                    answers={question.answers}
                    selectedAnswerId={question.selectedAnswerId}
                    onSelect={handleAnswerSelect}
                />
                <ButtonsWrapper>
                    <Button
                        onClick={() => {
                            gotoPrevious && gotoPrevious();
                        }}
                        fill="outline"
                        className={!gotoPrevious ? 'btn-navigate-disabled' : 'btn-navigate'}
                        disabled={!gotoPrevious}
                    >
                        {t('common.previous')}
                    </Button>
                    <Button
                        onClick={() => {
                            gotoNext && gotoNext();
                        }}
                        fill="outline"
                        className={!gotoNext ? 'btn-navigate-disabled' : 'btn-navigate'}
                        disabled={!gotoNext}
                    >
                        {t('common.next')}
                    </Button>
                </ButtonsWrapper>
            </QuestionContent>
        </GradualQuestionSlideWrapper>
    );
};

export default GradualQuestionSlide;
